import { convertHexToRgbA } from '../utils';

export const BACKGROUND = {
	main: '#1D2159',
	secondary: '#12143D',
	snackbar: '#1E1E30',
	input: '#05051B',
	modalView: convertHexToRgbA('#12143D', 0.8),
	modalViewSecondary: convertHexToRgbA('#1D2159', 0.8)
};

export const ICON = {
	main: '#EAAE16',
	secondary: '#7B756B',
	chevron: '#8195DF',
	hover: '#97ACFB',
	pressed: '#6F80C1',
	alwaysWhite: '#ffffff',
	notification: '#D63854',
	warning: '#E37B4C',
	deposit: '#A4DF28'
};

export const CONTROL = {
	primary: '#EAAE16',
	hover: '#FFD029',
	pressed: '#D39D14',
	disabled: '#2C2C4A',
	secondary: '#78AA0F',
	secondaryHover: '#9EE509',
	secondaryPressed: '#60880C',
	dark: '#2E4B96',
	darkHover: '#375AB4',
	darkPressed: '#253C78',
	darkToggle: '#586FAB',
	light: '#ffffff',
	lightHover: '#E5E5E5',
	lightPressed: '#D9D9D9',
	lightToggle: '#B7B7B7'
};

export const TEXT = {
	title: '#F6F6FC',
	subtitle: '#B5C0DF',
	body: '#A8B3D1',
	link: '#FFD029',
	error: '#FF6964',
	warning: '#EC985B',
	alwaysWhite: '#ffffff',
	alwaysDark: '#292621'
};

export const OTHER = {
	calendarDefault: convertHexToRgbA('#12143D', 0.8),
	calendarActive: '#12143D',
	calendarBackgroundWhite: convertHexToRgbA('#ffffff', 0.25),
	calendarTextWhite: '#ffffff',
	calendarBackgroundDarkYellow: '#333217',
	calendarTextYellow: '#EAAE16',
	calendarBackgroundDarkGreen: '#2E4105',
	calendarTextGreen: '#78AA0F',
	calendarBackgroundDarkPurple: '#3A2159',
	calendarTextPurple: '#8F6ED4',
	calendarBackgroundDarkBlue: '#19334F',
	calendarTextBlue: '#1D92FF'
};
